import React from 'react';
import styles from './Sessions.module.css';

const Sessions: React.FC = () => {
  return (
    <section
      className={styles.sessions}
    >
      <div className={styles.container}>
        <div className={styles.left}>
          <h2 className={styles.title}>SESSIONS THÉMATIQUES</h2>
          <p className={styles.text}>
            Participez à des sessions dédiées à la transformation digitale des
            distributeurs B2B pour repartir avec des idées, des use cases et des
            méthodes.
          </p>
        </div>
        <div className={styles.right}>
          <img
            src="/assets/images/sessions-illustration.jpg"
            alt="Sessions thématiques"
            className={styles.image}
          />
        </div>
      </div>
    </section>
  );
};

export default Sessions;
